import { useAtom } from "jotai";
import { bookingsAtom, dateRangeAtom } from "./analysisAtoms";
import { useQuery } from "@tanstack/react-query";
import { mbxUserAtom } from "../../atoms/atoms";
import { format } from "date-fns";
import { execReadBySortkey } from "../../modules/DBService";
import _ from "lodash";

const providerScheduleByCompany = /* GraphQL */ `
    query ProviderScheduleByCompany(
        $companyId: String
        $scheduleinfo: ModelStringKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelProviderScheduleFilterInput
        $limit: Int
        $nextToken: String
    ) {
        providerScheduleByCompany(
            companyId: $companyId
            scheduleinfo: $scheduleinfo
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                scheduleinfo
                sdtutc
                tz
                latitude
                longitude
            }
            nextToken
        }
    }
`;

const bookingByCompany = /* GraphQL */ `
    query BookingByCompany(
        $companyId: String
        $startdateTimeblockid: ModelBookingByCompanyCompositeKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelBookingFilterInput
        $limit: Int
        $nextToken: String
    ) {
        bookingByCompany(
            companyId: $companyId
            startdateTimeblockid: $startdateTimeblockid
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                providerId
                desc
                location
                status
                timeblockid
                orderType
                timezone
                provider {
                    id
                    firstname
                    lastname
                    ratingstarsavg
                    numberofratings
                    AcceptanceRatios
                }
                client {
                    id
                    userId
                    user {
                        firstname
                        lastname
                        mobilephone
                    }
                }
            }
            nextToken
        }
    }
`;
export function useBookings() {
    const [dateRange] = useAtom(dateRangeAtom);
    const [, setBookings] = useAtom(bookingsAtom);
    const [mbxUser] = useAtom(mbxUserAtom);

    return useQuery({
        queryKey: ["bookings-bks", dateRange],
        queryFn: async () => {
            try {
                let readBookingsQuery = {
                    opname: "bookingByCompany",
                    op: bookingByCompany,
                    id: {
                        companyId: mbxUser.companyId
                    },
                    limit: 200,
                    sortDirection: "ASC",
                    skey: {
                        startdateTimeblockid: {
                            between: [
                                {
                                    startdate: format(
                                        dateRange.start,
                                        "yyyy-MM-dd'T'00:00:00-00:00"
                                    )
                                },
                                {
                                    startdate: format(
                                        dateRange.end,
                                        "yyyy-MM-dd'T'23:59:59XXX"
                                    )
                                }
                            ]
                        }
                    }
                };
                const { items: rangeBookings } =
                    await execReadBySortkey(readBookingsQuery);
                const { items: rangeBKs } = await execReadBySortkey({
                    opname: "providerScheduleByCompany",
                    op: providerScheduleByCompany,
                    id: {
                        companyId: mbxUser.companyId
                    },
                    skey: {
                        scheduleinfo: {
                            between: [
                                `BK|${format(
                                    dateRange.start,
                                    "yyyy-MM-dd 00:00"
                                )}`,

                                `BK|${format(
                                    dateRange.end,
                                    "yyyy-MM-dd 23:59"
                                )}`
                            ]
                        }
                    },
                    limit: 500
                });
                rangeBKs.forEach((bk) => {
                    const matchedBookingIndex = rangeBookings.findIndex(
                        (booking) =>
                            booking.timeblockid ===
                            `${bk.id}::${bk.scheduleinfo}`
                    );
                    if (matchedBookingIndex !== -1) {
                        rangeBookings[matchedBookingIndex].coords = {
                            lat: bk.latitude,
                            lng: bk.longitude
                        };
                    }
                });
                return rangeBookings;
            } catch (e) {
                console.log("error bookings-bks", e);
            }
        },
        onSuccess: (rangeBookings) => {
            const filterOutBookingsWithoutCoords = rangeBookings.filter(
                (booking) => booking.coords?.lat && booking.coords?.lng
            );
            const uniqueBookingsByGeoLoc = _.uniqBy(
                filterOutBookingsWithoutCoords,
                (booking) => `${booking.coords.lat},${booking.coords.lng}`
            );
            setBookings(uniqueBookingsByGeoLoc);
        }
    });
}
